<template>
    <div class="wrapper">
        <div class="section section-blogs-2 topsearch">
            <div class="container main">
                <div class="md-layout">
                    <div
                        class="md-layout-item md-size-100 md-small-size-100 mx-auto"
                    >
                        <router-link :to="{ name: 'AllDicts' }" id="buttonback">
                            <md-icon>keyboard_arrow_left</md-icon>
                            Назад к справочникам
                        </router-link>
                    </div>
                    <div
                        class="md-layout-item md-size-100 md-small-size-100 mx-auto"
                    >
                        <div class="name">
                            <h3 class="title">
                                Редактирование справочника SourceName:
                            </h3>
                            <div
                                class="md-layout-item md-size-100 md-xsmall-size-100 savebtn"
                            >
                                <div class="md-layout">
                                    <div
                                        class="md-layout-item md-size-100 md-xsmall-size-100 savebtn text-right"
                                    >
                                        <button
                                            class="md-button"
                                            type="button"
                                            @click="toggleShowOnlyActive"
                                        >
                                            <span class="md-ripple">
                                                {{
                                                    isShowOnlyActive
                                                        ? 'Отобразить неактивные'
                                                        : 'Скрыть неактивные'
                                                }}
                                            </span>
                                        </button>

                                        <router-link
                                            :to="{
                                                name: 'sourceNameItemData',
                                                params: {
                                                    id: 'new',
                                                    dictCode: dictId,
                                                    page: filterData.page,
                                                },
                                            }"
                                            class="md-primary"
                                            tag="md-button"
                                        >
                                            Добавить новый элемент
                                        </router-link>
                                    </div>
                                </div>
                                <md-card class="md-card-plain">
                                    <md-card-content>
                                        <md-table
                                            class="table-shopping"
                                            v-model="listFiltered"
                                            md-sort="id"
                                            md-sort-order="asc"
                                        >
                                            <md-table-row
                                                slot="md-table-row"
                                                slot-scope="{ item }"
                                            >
                                                <md-table-cell
                                                    md-label="Id элемента"
                                                    md-sort-by="id"
                                                >
                                                    <router-link
                                                        :to="{
                                                            name:
                                                                'sourceNameItemData',
                                                            params: {
                                                                id: item.id,
                                                            },
                                                        }"
                                                    >
                                                        {{ item.id }}
                                                    </router-link>
                                                </md-table-cell>
                                                <md-table-cell
                                                    md-label="SourceName"
                                                >
                                                    <router-link
                                                        :to="{
                                                            name:
                                                                'sourceNameItemData',
                                                            params: {
                                                                id: item.id,
                                                            },
                                                        }"
                                                    >
                                                        {{ item.name }}
                                                    </router-link>
                                                </md-table-cell>
                                                <md-table-cell
                                                    md-label="Описание"
                                                >
                                                    <router-link
                                                        :to="{
                                                            name:
                                                                'sourceNameItemData',
                                                            params: {
                                                                id: item.id,
                                                            },
                                                        }"
                                                    >
                                                        {{ item.desc }}
                                                    </router-link>
                                                </md-table-cell>
                                                <md-table-cell
                                                    md-label="Активность"
                                                >
                                                    {{
                                                        item.status === 'A'
                                                            ? 'Активный'
                                                            : 'Неактивный'
                                                    }}
                                                </md-table-cell>
                                                <md-table-cell>
                                                    <router-link
                                                        :to="{
                                                            name:
                                                                'sourceNameItemData',
                                                            params: {
                                                                id: item.id,
                                                                dictCode: dictId,
                                                                action:
                                                                    'delete',
                                                            },
                                                        }"
                                                        event=""
                                                        @click.native.prevent="
                                                            confirmDelete({
                                                                name:
                                                                    'sourceNameItemData',
                                                                params: {
                                                                    id: item.id,
                                                                    dictCode: dictId,
                                                                    action:
                                                                        'delete',
                                                                },
                                                            })
                                                        "
                                                    >
                                                        <md-icon
                                                            >delete</md-icon
                                                        >
                                                    </router-link>
                                                </md-table-cell>
                                            </md-table-row>
                                        </md-table>
                                    </md-card-content>
                                </md-card>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { checkAuthentication, reAuthenticate } from '@/utils/auth-api';
import { getItem } from '@/utils/dict-api';

export default {
    mixins: [],
    props: ['dictionaryId', 'page'],
    bodyClass: 'dictionary-list',
    data() {
        return {
            options: [],
            dictId: 'sourcename',
            dictionaryListData: [],
            filterData: {
                page: this.page || 1,
            },
            isShowOnlyActive:
                localStorage.getItem('source_name_show_only_active') === 'true',
        };
    },
    computed: {
        listFiltered() {
            return this.isShowOnlyActive
                ? this.dictionaryListData.filter(item => item.status === 'A')
                : this.dictionaryListData;
        },
    },
    methods: {
        getDistrict() {
            checkAuthentication(this.$router, this.$route).then(response => {
                getItem(this.dictId)
                    .then(result => {
                        this.dictionaryListData = result;
                    })
                    .catch(error => {
                        reAuthenticate(this.$router, this.$route, error);
                    });
            });
        },
        confirmDelete(route) {
            if (confirm('Действительно удалить?')) {
                this.$router.push(route);
            }
        },
        toggleShowOnlyActive() {
            this.isShowOnlyActive = !this.isShowOnlyActive;
            localStorage.setItem(
                'source_name_show_only_active',
                this.isShowOnlyActive
            );
        },
    },
    created() {
        this.getDistrict();
    },
};
</script>
<style lang="scss" scoped type="text/scss">
.savebtn {
    margin-right: 0px;
    padding-right: 5px;
}
</style>
